module.exports = __webpack_public_path__ + "static/media/file_icon.5c2a2fda.svg";